/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class TranslationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTranslations
   */
  static readonly GetTranslationsPath = '/api/public/translations/{locale}';

  /**
   * Get Translations.
   *
   * Get Translations.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTranslations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTranslations$Response(params: {
    locale: string;
  }): Observable<StrictHttpResponse<{  }>> {

    const rb = new RequestBuilder(this.rootUrl, TranslationService.GetTranslationsPath, 'get');
    if (params) {
      rb.path('locale', params.locale, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{  }>;
      })
    );
  }

  /**
   * Get Translations.
   *
   * Get Translations.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTranslations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTranslations(params: {
    locale: string;
  }): Observable<{  }> {

    return this.getTranslations$Response(params).pipe(
      map((r: StrictHttpResponse<{  }>) => r.body as {  })
    );
  }

}
